import React from 'react';
import { SelectField } from '@ffw/randstad-shared-components/build';
import UI from '@UI/hoc/UI';

export default UI(SelectField)();
